import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Logo extends React.PureComponent {
    render() {
        return (
            <div className={styles.logo}>
                <a href="//www.ifeng.com/" target="_blank" rel="noreferrer" title="凤凰网">
                    <span />
                </a>
            </div>
        );
    }
}

export default errorBoundary(Logo);
